import styles from './UploadLogs.module.scss'
export const TitleRow = ({ hasNextAction = true }) => {
  return (
    <div
      className={[styles.titleRow, hasNextAction ? styles.titleWithNextAction : ''].join(
        ' '
      )}
    >
      <div className={styles.uploadTimeCol}>Time</div>
      <div className={styles.timeRangeCol}>Date range</div>
      <div className={styles.uploadedNumberCol}>Uploaded</div>
      <div className={styles.uploadedNumberCol}>New</div>
      <div className={styles.uploadedNumberCol}>Updated</div>
      <div className={styles.uploadedNumberCol}>Dupes</div>
      <div className={styles.uploadedNumberCol}>Invalid</div>
      <div className={styles.statusCol}>Status</div>
      <div className={styles.downloadCol}></div>
    </div>
  )
}
